import type { TOC } from '@ember/component/template-only';

import CommonUiIcon from 'webapp/components/common/ui-icon';

import type SourceType from 'webapp/models-custom/source-type';

export interface Args {
	model: SourceType;
}

const SourceTypeInfoTabsHelpArticlesComponent: TOC<Args> = <template>
	<div class="help-articles">
		<ul class="links">
			{{#each @model.uniqueArticleUrls as |article|}}
				<li>
					<CommonUiIcon @name="FileText" @size="sm" />
					<a href={{article.url}} target="_blank">{{article.title}}</a>
				</li>
			{{/each}}
		</ul>
	</div>
</template>;

export default SourceTypeInfoTabsHelpArticlesComponent;
